exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fin-logo-wrapper .hero,\n.fin-logo-wrapper .highlight {\n  text-align: center; }\n\n.fin-logo-wrapper .highlight {\n  font-size: 29.6px;\n  font-size: 1.85rem;\n  color: #185de2;\n  font-weight: 500; }\n\n.fin-logo-wrapper .graphic {\n  margin: 0 32px 0 0;\n  margin: 0 2rem 0 0; }\n\n.fin-logo-wrapper .title {\n  font-size: 64px;\n  font-size: 4rem; }\n\n.fin-logo-wrapper .message {\n  text-align: center; }\n", ""]);

// exports
